import { jsx as _jsx } from "react/jsx-runtime";
import { getDepartamentos } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function Departamentos() {
    return (_jsx(GridBase, { pagina: PAGINAS.DEPARTAMENTOS, paginaPermissao: FUNCIONALIDADES.DEPARTAMENTOS, rota: ROUTES.DEPARTAMENTOS, fetchData: function (str, _filter, pag) { return getDepartamentos(str, pag); }, columns: COLUNAS }));
}
